import { render, staticRenderFns } from "./BookingRoomForm.vue?vue&type=template&id=04a8fd39"
import script from "./BookingRoomForm.vue?vue&type=script&lang=js"
export * from "./BookingRoomForm.vue?vue&type=script&lang=js"
import style0 from "./BookingRoomForm.vue?vue&type=style&index=0&id=04a8fd39&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports